import { Component, OnInit, ViewChild } from '@angular/core';
import { Kpi } from '../../../models/common';
import { User } from '../../../models/user';
import { CommonConstant } from '../../app.constants';
import { FilterSearch } from '../../../models/filter-search';
import { AuthService } from '../../core/auth.service';
import { UserService } from '../../services/user.service';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {DiscoverService} from '../../services/discover/discover.service';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import { ShortMessage } from '../../../models/dashboard';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';

@Component({
  selector: 'influencer-home',
  templateUrl: './influencer-home.component.html',
  styleUrls: ['./influencer-home.component.scss']
})
export class InfluencerHomeComponent extends AbstractAchooComponent implements OnInit {
  public user: User;
  private currentInfluencer: any;
  public dashboardKPIData: Kpi | null;
  public scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
  public throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE_100;
  public currentFilterSearch: FilterSearch = new FilterSearch();
  public storedFilterSearch: FilterSearch;
  public socialFilterOptions: any[];
  public currentSocialFilter: any;
  public dashboardPosts: any[] = [];
  public influencerGroupId = 0;
  public recentMessages: any;

  @ViewChild('confirmRemoveMessageDialog')
  confirmRemoveMessageDialog: AchooPopupComponent;

  // infinity loader
  private searchAfter: any[];
  public editingMessages: boolean;
  public messageToRemove: ShortMessage;


  constructor(
    private auth: AuthService,
    public userService: UserService,
    private influencerService: InfluencerService,
    private discoverService: DiscoverService,
    private placeholderService: PlaceholderVisibilityService,
    private dashboardService: DashboardService,
    private modalService: ModalService
  ) {
    super(userService);
    this.user = new User();
    this.currentFilterSearch.orderBy = 'latest';
  }

  ngOnInit() {
    if (this.auth.isAuth()) {
      this.user = this.auth.getUser();
    }
    this.currentInfluencer = this.userService.getInfluencerInfo();
    // intialize search criteria
    this.currentFilterSearch = new FilterSearch();
    this.currentFilterSearch.limit = 50;
    this.currentFilterSearch.offset = 0;
    this.currentFilterSearch.orderBy = 'latest';
    this.currentFilterSearch.period = 60;
    // fetch data
    this.loadInfluencerKpi();
    this.fetchListChannel();
    this.fetchRecentMessages();
  }

  companyChangeCallback(companyId: any) {
  }

  fetchListChannel() {
    if (this.currentInfluencer) {
      this.influencerService.loadListChannelOfInfluencer(this.currentInfluencer.id).subscribe((res) => {
        this.socialFilterOptions = res.map(c => ({
          id: c.id,
          handle: c.handle,
          name: c.platform ? `${c.platform.name}(${c.handle})` : null,
          platformId: c.platform ? c.platform.id : null,
        }));
        if (this.socialFilterOptions.length > 0) {
          this.currentSocialFilter = this.socialFilterOptions[0];
          const { handle, platformId } = this.currentSocialFilter;
          this.getPostByHandleAndPlatform(handle, platformId, false);
        }
      });
    }
  }

  loadInfluencerKpi() {
    this.influencerService.getInfluencer(this.currentInfluencer.id).subscribe((res) => {
      this.dashboardKPIData = this.influencerService.influencerDetails.globalKpi;
    });
  }

  onScrollDown() {
    const { handle, platformId } = this.currentInfluencer;
    this.getPostByHandleAndPlatform(handle, platformId, true);
  }

  onChangeChannel(e) {
    if (e) {
      const { handle, platformId } = e;
      this.getPostByHandleAndPlatform(handle, platformId, false);
    }
  }

  eventOrderList(orderField) {
    if (
      this.currentFilterSearch &&
      !this.compareCurrentFilterWithPreviousFilter()
    ) {
      this.currentFilterSearch.orderBy = orderField;
      this.onChangeSearchCriteria(this.currentFilterSearch);
    }
  }

  onChangeSearchCriteria(orderByFilter: FilterSearch) {
    this.fetchPost(false);
  }

  editMessage() {
    this.editingMessages = !this.editingMessages;
  }

  private compareCurrentFilterWithPreviousFilter() {
    return (
      JSON.stringify(this.currentFilterSearch) ===
      JSON.stringify(this.storedFilterSearch)
    );
  }

  private getPostByHandleAndPlatform(handle, platformId, isScrolling) {
    this.currentFilterSearch.mentions = [`@${handle}`];
    this.currentFilterSearch.platforms = [platformId];
    this.fetchPost(isScrolling);
  }

  private fetchPost(isScrolling) {
    if (isScrolling) {
      this.currentFilterSearch.searchAfter = this.searchAfter;
    } else {
      this.currentFilterSearch.searchAfter = [];
    }

    delete this.currentFilterSearch['topics'];
    delete this.currentFilterSearch['industries'];
    this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);
    this.discoverService.searchPosts(this.currentFilterSearch)
    // update the catching data with preloaded data	        // update the catching data with preloaded data
      .subscribe((res) => {
        // update the total result post and pagination data
        this.updateSearchAfter(res.lastSortValues);
        const nextResult = res.posts.filter(p => p.influencer_id === this.currentInfluencer.id)
          .map(p => Object.assign({}, p, {
            influencerName: this.currentInfluencer.name || this.user.fullName
          }));
        if (isScrolling) {
          this.dashboardPosts = this.dashboardPosts.concat(nextResult);
        } else {
          this.dashboardPosts = nextResult;
        }
        this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
      }, (err) => {
        this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
      });
  }

  private updateSearchAfter(lastSortValues) {
    this.searchAfter = [];
    if (lastSortValues != null && lastSortValues.length > 0) {
      this.currentFilterSearch.searchAfter = lastSortValues;
    }
  }

  private fetchRecentMessages() {
    this.dashboardService.fetchRecentMessages()
      .subscribe((res) => {
        this.recentMessages = res;
      });
  }

  public onConfirmRemoveMessage(message: ShortMessage) {
    if (!message) {
      return;
    }
    this.messageToRemove = message;
    this.modalService.open(this.confirmRemoveMessageDialog);
  }

  public oncConfirmRemoveMessage() {
    console.log('Remove message confirmed.', this.messageToRemove); // Test code
    this.modalService.close();
    this.messageToRemove = null;
  }

  public closeConfirmRemoveMessage() {
    this.modalService.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/influencer-home.component.ts